import { render, staticRenderFns } from "./UploadAnnotation.vue?vue&type=template&id=1e2529e2&scoped=true&"
import script from "./UploadAnnotation.vue?vue&type=script&lang=js&"
export * from "./UploadAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./UploadAnnotation.vue?vue&type=style&index=0&id=1e2529e2&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2529e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2529e2')) {
      api.createRecord('1e2529e2', component.options)
    } else {
      api.reload('1e2529e2', component.options)
    }
    module.hot.accept("./UploadAnnotation.vue?vue&type=template&id=1e2529e2&scoped=true&", function () {
      api.rerender('1e2529e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/UploadAnnotation.vue"
export default component.exports